import palette from "layouts/ThemeProvider/palette";

const buttonDefault = {
  height: 40,
  fontSize: 15,
  padding: "0px 30px",
  borderWidth: 1.5,
  borderRadius: 20,
  textTransform: "none",
};

const hoverTransform = {
  transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
  "&:hover": {
    "@media (hover: hover)": {
      transform: "scale(1.1)",
    },
  },
};

const fullDefault = {
  ...buttonDefault,
  ...hoverTransform,
};

const outlinedDefault = (color) => {
  return {
    borderColor: color,
    color: palette.primary.main,
    "&:hover": {
      "@media (hover: hover)": {
        background: color,
        color: "white",
      },
    },
  };
};

const containedDefault = (color) => {
  return {
    background: color,
  };
};

export default {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
      disableElevation: true,
    },
    styleOverrides: {
      outlined: fullDefault,
      outlinedDark: outlinedDefault(palette.dark.main),
      outlinedPrimary: outlinedDefault(palette.primary.main),
      outlinedPrimaryLight: outlinedDefault(palette.primary.light),
      outlinedSecondary: outlinedDefault(palette.secondary.main),
      outlinedSecondaryLight: outlinedDefault(palette.secondary.light),
      contained: fullDefault,
      containedDark: containedDefault(palette.dark.main),
      containedPrimary: containedDefault(palette.primary.main),
      containedPrimaryLight: containedDefault(palette.primary.light),
      containedPrimaryGradient: containedDefault(palette.primary.gradient),
      containedSecondary: containedDefault(palette.secondary.main),
      containedSecondaryLight: containedDefault(palette.secondary.light),
      containedSecondaryGradient: containedDefault(palette.secondary.gradient),
      sizeXsmall: {
        height: 26,
        fontSize: 12,
        padding: "6px 5px",
      },
      sizeLarge: {
        height: 60,
        borderRadius: 30,
        borderWidth: 2,
        fontSize: 20,
        padding: "0px 34px",
      },
    },
  },
};
